import { getDb } from "./database";

export async function saveAppSetting(key: string, value: unknown, updatedAt = new Date().toISOString()): Promise<void> {
  const db = await getDb();
  await db.put("appSettings", {
    key,
    value,
    updatedAt
  });
}

export async function getAppSetting<T>(key: string): Promise<T | undefined> {
  const db = await getDb();
  const setting = await db.get("appSettings", key);
  return setting?.value as T | undefined;
}
